import React from 'react';
import { MessageInput } from 'stream-chat-react';
import { CommentBox } from './commentBox';

type CommentInputProps = Omit<
  React.ComponentProps<typeof MessageInput>,
  'Input'
>;

export const CommentInput = (props: CommentInputProps) => {
  return <MessageInput {...props} Input={CommentBox} />;
};
